export default {"src":"/_next/static/media/standard_flexible.bf75d451.svg","height":403,"width":525,"blurWidth":0,"blurHeight":0};